<template>
  <ItemTable
    v-bind="itemTableProps"
  />
</template>
<script>
import { ItemTableConsts, ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapActions } from 'vuex';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';

const storeModule = StoreModuleMap[ItemTypeConsts.workdayWorker];

export default {
  name: 'WorkdayImportSelection',

  components: {
    ItemTable,
  },

  props: {
    showResults: {
      default: () => {},
      type: Function,
    },
    workdayId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      itemTableProps: {
        columns: [
          {
            bodyComponent: 'EditableInput',
            bodyComponentProps: {
              field: 'firstName',
              storeModule,
              type: 'text',
            },
            headingText: 'First Name',
            sortBy: 'firstName',
          },
          {
            bodyComponent: 'EditableInput',
            bodyComponentProps: {
              field: 'lastName',
              storeModule,
              type: 'text',
            },
            headingText: 'Last Name',
            sortBy: 'lastName',
          },
          {
            bodyComponent: 'EditableInput',
            bodyComponentProps: {
              field: 'email',
              storeModule,
              type: 'email',
              validation: 'required|email',
            },
            headingText: 'Email',
            sortBy: 'email',
          },
          {
            bodyComponent: 'EditableInput',
            bodyComponentProps: {
              field: 'username',
              storeModule,
              type: 'text',
              validation: 'required|regex:^[a-z][-_.a-z0-9]*$',
            },
            headingText: 'Username',
            sortBy: 'username',
          },
          {
            classNames: {
              body: ['alignWithInputs'],
            },
            dataField: 'hire_date',
            headingText: 'Hire Date',
          },
        ],
        details: true,
        detailsButtonType: ItemTableConsts.detailsButtonType.rowExpand,
        detailsComponent: 'WorkdayWorkerPreviewAttributes',
        hasSelectColumn: true,
        inPanel: false,
        itemType: ItemTypeConsts.workdayWorker,
        legacyRowStyles: false,
        showActionBar: false,
        showSearchForm: false,
        useLargeTableCells: true,
      },
    };
  },

  mounted() {
    this.setWorkdayId({ workdayId: this.$props.workdayId });
  },

  methods: {
    ...mapActions(storeModule, [
      'setWorkdayId',
    ]),
  },
};
</script>
